import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import CategoryModal from "../../components/modal/CategoryModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { langState, langText } from "../../recoil/lang";
import { useRecoilValue, useRecoilState } from "recoil";
import {
  CouponType,
  OrderCouponType,
  OrderDataType,
  OrderInfoType,
  paymentRealmType,
} from "../../recoil/type";
import ApiController from "../../controller/ApiController";
import moment from "../../utils/moment";
import {
  getProductName,
  getPrdName,
  getOptionTypeName,
  getOptionName,
  contentName,
} from "../../utils/util";
import LogController from "../../controller/LogController";

const OrderDetails = () => {
  const location = useLocation();
  const orderData: OrderDataType = location.state;
  const [lang, setLang] = useRecoilState<number>(langState);
  const [orderDetailData, setOrderDetailData] = useState<OrderInfoType>();
  const navigate = useNavigate();

  // 쿠폰
  const [couponList, setCouponList] = useState<OrderCouponType[]>([]);

  const navigateHome = () => {
    navigate(`/`);
  };

  const navigateBack = () => {
    LogController.click({
      path: "orderDetails",
      params: "click",
      params2: "이전 화면 이동 클릭",
    });
    navigate(-1);
  };

  const navigateMaster = () => {
    LogController.click({
      path: "orderDetails",
      params: "click",
      params2: "홈버튼 클릭",
    });
    navigate(`/master`);
  };

  React.useEffect(() => {
    ApiController.order.getOrderByOrderId(orderData.order_id).then((res) => {
      if (res.ok) {
        console.log("getOrder", res.data);
        setOrderDetailData(res.data);
        // setTest(JSON.stringify(res.data.order.child[0]));
        setCouponList(res.data.order.child[0].coupons);
      }
    });
  }, []);

  const RenderOrderItem = () => {
    return (
      <div>
        <div className="historyTime">
          <p>{moment(orderData.created_at).format("YYYY/MM/DD HH:mm:ss")}</p>
        </div>
        <div className="orderWrap">
          <div className="storeTitle">
            <h2>{orderData.store_name}</h2>
            <div className="badge">
              <h3>{langText.paymentListModal_title_pickup_location[lang]}</h3>
              <h3>⮕</h3>
              <h3 className="pickupName">
                {
                  orderDetailData?.order?.child[0]?.pickup_name &&
                    (lang === 0
                      ? orderDetailData?.order?.child[0]?.pickup_name
                      : orderDetailData?.order?.child[0]?.pickup_name_en)
                  // contentName(
                  //   orderDetailData?.order?.child[0]?.pickup_name,
                  //   lang
                  // )
                }
              </h3>
            </div>
          </div>
          <div className="paymentListWrap">
            {orderDetailData?.order.child.map((child, index: number) => {
              return (
                <>
                  {child.detail.map((detail, index) => {
                    return (
                      <div key={index} className="menuContent">
                        <div className="orderIndex">
                          <p>{index + 1}</p>
                        </div>
                        <div className="orderList">
                          <div className="orderTitle">
                            <div className="menuNameWrap">
                              <div
                                className={
                                  detail.product_discount_amount > 0
                                    ? "menuNameShot"
                                    : "menuName"
                                }
                              >
                                <h3>{getProductName(detail, lang)}</h3>
                              </div>
                              {detail.product_discount_amount > 0 && (
                                <div className="badge">
                                  <h3>
                                    {detail.product_discount_amount}원{" "}
                                    {langText.discount[lang]}
                                  </h3>
                                </div>
                              )}
                            </div>
                            <h3 className="menuCount">
                              {detail.product_quantity}
                            </h3>
                            <h3 className="menuPrice">
                              {detail.product_total_amount.toLocaleString()}원
                            </h3>
                          </div>
                          {detail.options.map((option, optionIndex: number) => (
                            <div key={optionIndex} className="orderOption">
                              <img
                                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                                alt="옵션아이콘"
                              />
                              <div className="optionCategory">
                                <span>&#91;</span>
                                <p className="optionCategoryName">
                                  [{getOptionTypeName(option, lang)}]
                                </p>
                                <span>&#93;</span>
                              </div>
                              <p className="optionName">
                                {getOptionName(option, lang)}
                              </p>
                              {/* <p className="optionPrice">
                                        {option.option_price.toLocaleString()}원
                                      </p> */}
                            </div>
                          ))}
                          {detail.set_prd_type_list.map(
                            (set_product, prd_group_index) => (
                              <div className="optionLine">
                                <img
                                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                                  alt="옵션아이콘"
                                />
                                {set_product.set_prd_type_min > 0 ? (
                                  <p className="optionCategoryName">
                                    [
                                    {
                                      langText.setOptionModal_configuration[
                                        lang
                                      ]
                                    }
                                    {prd_group_index + 1}]
                                  </p>
                                ) : (
                                  <p className="optionCategoryName">
                                    [{langText.setOptionModal_addtional[lang]}]
                                  </p>
                                )}
                                <div className="optionCategory">
                                  {set_product.set_product.map(
                                    (pickProduct, prd_index) => (
                                      <div
                                        className="setOrderOption"
                                        key={prd_index}
                                      >
                                        <div className="optionLineChild">
                                          <p>
                                            {getProductName(pickProduct, lang)}
                                          </p>
                                          {pickProduct.options.length > 0 && (
                                            <div className="optionBreak">
                                              <div className="optionBreakLine"></div>
                                              <h5>
                                                (
                                                {
                                                  langText
                                                    .setOptionModal_option[lang]
                                                }
                                                )
                                              </h5>
                                            </div>
                                          )}
                                          <div className="setOptionPickOption">
                                            {pickProduct.options.map(
                                              (
                                                pickOptionGroup,
                                                option_index
                                              ) => (
                                                <span key={option_index}>
                                                  {getOptionName(
                                                    pickOptionGroup,
                                                    lang
                                                  )}
                                                </span>
                                              )
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    );
                  })}
                </>
              );
            })}
          </div>
          <div className="totalOrder">
            <h2 className="productName">
              {langText.paymentListModal_title_totalPayment[lang]}
            </h2>
            <h2 className="productQuantity">
              {orderDetailData?.order?.child[0]?.detail.reduce(
                (sum, obj) => sum + (obj.product_quantity || 0),
                0
              )}
            </h2>
            <h2 className="productPrice">
              {orderDetailData?.order?.child[0]?.total_amount_incl?.toLocaleString()}
              원
            </h2>
          </div>
          <div className="totalWrap">
            <div className="totalContent">
              <h2>{langText.paymentListModal_title_orderAmount[lang]}</h2>
              <h3>
                {(
                  orderDetailData?.order?.child[0]?.total_amount_org! +
                  orderDetailData?.order?.child[0]?.prd_discount_amount!
                ).toLocaleString()}
                원
              </h3>
            </div>
            <div className="totalContent">
              <h2>{langText.paymentListModal_title_delivery_cost[lang]}</h2>
              <h3>
                {orderDetailData?.order?.child[0].delivery_tip.toLocaleString()}
                원
              </h3>
            </div>
            {/* TODO 번역 객실관리팁 */}
            {orderDetailData && orderDetailData.order.child[0].room_tip > 0 && (
              <div className="totalContent">
                <h2>{langText.room_tip[lang]}</h2>
                <h3>
                  {orderDetailData?.order?.child[0].room_tip.toLocaleString()}원
                </h3>
              </div>
            )}
            {/* 할인금액 */}
            {(orderDetailData?.order?.child[0].discount_amount! +
              orderDetailData?.order?.child[0].prd_discount_amount! >
              0 ||
              couponList.length > 0) && (
              <>
                <div className="totalContent">
                  <div className="row gap">
                    <h2>{langText.paymentListModal_title_discount[lang]}</h2>
                    <div className="badge">
                      <h3>
                        🌟 {langText.paymentListModal_maximum_discount[lang]}
                      </h3>
                    </div>
                  </div>
                  <h3>
                    {orderDetailData?.order?.child[0].discount_amount! > 0
                      ? `-${(
                          orderDetailData?.order?.child[0].discount_amount! +
                          orderDetailData?.order?.child[0].prd_discount_amount!
                        ).toLocaleString()}원`
                      : `0원`}
                  </h3>
                </div>
                {orderDetailData?.order?.child[0].prd_discount_amount! > 0 && (
                  <div className="totalContent discount">
                    <div className="row gap">
                      <img
                        src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                        alt="옵션아이콘"
                      />
                      <h4>
                        {langText.paymentListModal_title_product_discount[lang]}
                      </h4>
                    </div>
                    <h4>
                      -
                      {orderDetailData?.order?.child[0].prd_discount_amount.toLocaleString()}
                      원
                    </h4>
                  </div>
                )}
                {couponList.length > 0 && (
                  <div className="totalContent discount coupon">
                    <div className="row gap">
                      <img
                        src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                        alt="옵션아이콘"
                      />
                      <h4>
                        {langText.paymentListModal_title_coupon_discount[lang]}
                      </h4>
                    </div>
                    <div className="couponListWrap">
                      {couponList.map((item, index: number) => {
                        return (
                          <div key={index} className="discountInfo">
                            <div className="couponName">
                              <h4>•{item.coupon_name}</h4>
                            </div>
                            <h4>
                              -
                              {(
                                item.com_discount_amount +
                                item.store_discount_amount
                              ).toLocaleString()}
                              원
                            </h4>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </>
            )}
            {orderDetailData?.order?.child[0]?.inquiry &&
              orderDetailData?.order?.child[0]?.inquiry !== "" && (
                <div className="orderRequest">
                  <h3>{langText.paymentListModal_title_request[lang]}</h3>
                  <textarea
                    value={orderDetailData?.order?.child[0]?.inquiry}
                    disabled={true}
                  />
                </div>
              )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Style>
      <div className="knockContainer">
        <div className="header">
          <img
            onClick={navigateMaster}
            src={`${process.env.PUBLIC_URL}/knockknock/img/knockMainLogo.png`}
            className="logoButton"
            alt="노크노크 로고"
          />
        </div>
        <div className="content">
          <h1>{langText.orderStatus_button_history[lang]}</h1>
          <RenderOrderItem />
        </div>
        <div className="bottomButtonWrap">
          <button className="backButton" onClick={navigateBack}>
            {langText.button_back[lang]}
          </button>
          <button className="homeButton" onClick={navigateMaster}>
            {langText.button_home[lang]}
          </button>
        </div>
      </div>
    </Style>
  );
};
export default OrderDetails;

const Style = styled.div`
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  .knockContainer {
    height: 100%;
    min-height: 100vh;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    background: #000000;
  }
  .header {
    padding: 22px 24px 10px 24px;
  }

  /* content */
  .content {
    width: 100%;
    padding: 0 41px;
    padding-bottom: 20px;

    h1 {
      font-size: 36px;
      font-weight: 300;
      color: #fff;
      text-align: center;
    }
  }

  .orderWrap {
    border-radius: 10px;
    background: #2b2b2b;
  }

  /* RenderOrderItem */
  .historyTime {
    text-align: right;

    p {
      margin: 12px 0;
      font-size: 16px;
      font-weight: 500;
      color: #a7a7a7;
    }
  }

  .badge {
    padding: 3px 12px;
    border-radius: 50px;
    background: #40977f;

    h3 {
      white-space: nowrap;
      font-size: 14px;
      font-weight: 600;
      color: #fff;
    }
  }
  .row {
    display: flex;
    align-items: center;
  }
  .row.gap {
    gap: 10px;
  }

  /* modalHeader */
  .storeTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 36px 4px 64px;
    height: 6vh;

    h3 {
      font-size: 24px;
      font-weight: 500;
    }

    .badge {
      max-width: 45vw;
      display: flex;
      align-items: center;
      background: #ff6262;
      padding: 2px 18px;
      gap: 6px;
      h3 {
        font-size: 20px;
        font-weight: 500;
      }
      h3.pickupName {
        white-space: normal;
        word-break: break-all;
        max-width: 60%;
      }
    }
  }

  /* paymentListWrap */
  .paymentListWrap {
    width: 100%;
    min-height: 32vh;
    max-height: 32vh;
    padding: 14px 36px;
    overflow-y: auto;
    background: #232323;
    border-bottom: 1px solid #555;
    border-top: 1px solid #555;
  }
  /* .menuContent {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0;

    .orderIndex {
      margin-right: 8px;
      margin-top: 8px;
      border: 1px solid #555555;
      border-radius: 4px;

      p {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 8px 3px 8px;
        color: #e5e5e5;
        font-size: 12px;
        font-weight: 300;
      }
    }
  } */
  .menuContent {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    .orderIndex {
      margin-right: 8px;
      margin-top: 8px;
      border: 1px solid #555555;
      border-radius: 4px;

      p {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 8px 3px 8px;
        color: #e5e5e5;
        font-size: 12px;
        font-weight: 300;
      }
    }
  }

  /* orderList */
  .orderList {
    width: 95%;
    padding: 10px 0;
    border-bottom: 1px solid #3d3d3d;

    .orderTitle {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .orderMenu,
  .orderOption {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .orderOption {
    margin: 4px 0;
    justify-content: flex-start;

    p {
      font-size: 16px;
      font-weight: 300;
      color: #e5e5e5;
    }

    .optionCategory {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0 5px;
      max-width: 25%;

      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .optionName {
      flex: 0 0 80%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .optionPrice {
      flex: 0 0 23%;
      text-align: right;
      margin-left: auto;
    }
  }
  .menuNameWrap {
    flex: 0 0 50%;
    width: 50%;
    max-width: 300px;
    display: flex;
    align-items: center;
    padding: 2px 0;

    .badge {
      margin-left: 6px;
      h3 {
        padding: 1px 0 0 0;
        font-size: 12px;
      }
    }
  }
  .menuNameShot,
  .menuName {
    display: flex;

    h3 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .menuNameShot {
    max-width: 60%;
  }
  .menuName {
    max-width: 100%;
  }
  .menuCount {
    flex: 0 0 10%;
    text-align: center;
  }
  .menuPrice {
    flex: 0 0 25%;
    text-align: right;
  }

  .optionLine {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    margin: 4px 0;

    .optionCategoryName,
    p {
      margin: 0 4px;
      font-size: 16px;
      font-weight: 300;
      color: #e5e5e5;
      flex: 0 0 16%;
    }
  }

  .optionBreak {
    display: flex;
    align-items: center;

    .optionBreakLine {
      border-right: 1px solid #fff;
      margin-right: 4px;
      height: 16px;
    }
    h5 {
      font-size: 12px;
      font-weight: 300;
      color: #e5e5e5;
      white-space: nowrap;
    }
  }
  .optionLineChild {
    max-width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    p {
      white-space: nowrap;
    }
    .optionLineGroup {
      width: 100%;
    }
    .setOptionPickOption {
      max-width: 350px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #e5e5e5;

      span {
        font-size: 12px;
        font-weight: 300;
        color: #e5e5e5;
        margin-left: 4px;
        margin-bottom: 1px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  /* totalWrap */
  .totalWrap {
    height: 30vh;
    padding-top: 10px;
    padding-bottom: 30px;
  }
  .totalContent,
  .totalOrder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
    padding: 0 40px;

    h2,
    h3 {
      font-size: 20px;
      font-weight: 500;
    }
    .badge {
      h3 {
        font-size: 16px;
      }
    }
  }
  .totalOrder {
    h2 {
      font-size: 28px;
    }
    h2.quantity {
      margin-right: -16%;
    }
  }

  .totalContent.coupon {
    .row.gap {
      gap: 8px;
    }
    input {
      width: 160px;
      height: 36px;
      padding: 2px 16px;
      border-radius: 10px;
      background: none;
      border: 1px solid #9f9f9f;
      font-size: 20px;
      line-height: 30px;
      color: #ffffff;
    }
    button {
      border: 1px solid #4dd2ae;
      border-radius: 10px;
      padding: 2px 16px;
      h3 {
        font-size: 20px;
        line-height: 30px;
        color: #4dd2ae;
      }
    }
  }

  .totalContent.discount {
    margin-top: 8px;
    margin-left: 60px;
    justify-content: space-between;
    align-items: flex-start;

    .row.gap {
      gap: 6px;
    }
    h4 {
      font-size: 18px;
      line-height: 30px;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .totalContent.discount.coupon {
    overflow-y: auto;
    justify-content: space-between;
    margin: 0;
    margin-left: 60px;
    gap: 10px;
    .couponListWrap {
      width: calc(75% - 10px);
      height: 9vh;
      overflow-y: auto;
    }
    .discountInfo {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .couponName {
      max-width: 70%;
    }
    h4 {
      color: #4dd2ae;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .checkBox {
      margin-left: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      padding: 0;
      border: 1px solid #4dd2ae;
      border-radius: 5px;
    }
  }
  .totalOrder {
    margin: 0;
    padding: 20px 40px;
    background: #474747;
    border-bottom: 1px solid #555;
  }

  /* .commentBox {
    padding: 0 14px;
    margin-bottom: 6px;
    background: rgba(64, 151, 127, 0.5);
    border-radius: 50px;
    max-width: 100%;

    p {
      color: #ffffff;
      font-size: 14px;
      line-height: 24px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .commentBox:after {
    content: " ";
    height: 0;
    width: 0;
    left: 110px;
    position: absolute;
    border: 5px solid transparent;
    border-bottom-width: 0;
    border-top-color: rgba(64, 151, 127, 0.5);
  } */

  /* orderRequest */
  .orderRequest {
    margin: 0 40px;
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px solid #555;
    h2 {
      font-size: 22px;
      font-weight: 500;
      margin: 0;
    }
    h3 {
      margin-bottom: 8px;
      font-size: 20px;
      font-weight: 500;
    }
    .requestCheckbox,
    label {
      display: flex;
      align-items: center;
    }
    .requestCheckbox {
      margin: 11px 0 16px 0;
      justify-content: space-between;
    }
    input {
      margin-right: 10px;
      accent-color: #40977f;
    }
    span {
      font-size: 16px;
      font-weight: 400;
      color: #e5e5e5;
    }
    textarea {
      width: 100%;
      height: 40px;
      padding: 4px 16px;
      border-radius: 10px;
      background: none;
      border: 1px solid #9f9f9f;
      font-size: 20px;
      line-height: 30px;
      color: #ffffff;
    }
  }

  /* bottomButtonWrap */
  .bottomButtonWrap {
    width: 100%;
    position: fixed;
    bottom: 32px;
    display: flex;
    justify-content: space-between;
    padding: 0 41px;
    background: #000;

    button {
      width: 48%;
      padding: 17px;
      border: 2px solid #777777;
      border-radius: 10px;
      font-size: 24px;
      font-weight: 600;
      color: #fff;
    }
    .homeButton {
      background: #4dd2ae;
      color: #ffffff;
      border: 2px solid #4dd2ae;
    }
  }
`;
